export default "__VITE_ASSET__CIvc10rE__"